import Loading from "component/Loading";
import Modal from "component/Modal";
import { useLoginInfo } from "hook/loginInfo";
import { useWebSocket } from "hook/useWS";
import MicroModal from "micromodal";
import { Suspense, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { api_commonFetch } from "util";

export default function Home(){
    return (
        <Suspense fallback={<Loading/>}>
            <App/>
        </Suspense>
    );
}

export function App(){

    const navigate = useNavigate();
    const date = new Date();
    const [params, setParams] = useSearchParams();
    const [vo, setVO] = useState({
        searchStartDate : params.get('searchStartDate') || date.getFullYear() + "-01-01"
        , searchEndDate : params.get('searchEndDate') || date.getFullYear() + "-12-31"
        , roomId : params.get('roomId') || '1'
    });
    const [loading, setLoading] = useState(true);
    const loginInfo = useLoginInfo();


    const [fn_sendWs, msgList, connected] = useWebSocket(process.env.REACT_APP_WS_URL);
    

    const [ip, setIp] = useState('');
    const [msg, setMsg] = useState('');
    const msgListRef = useRef(null);

    const [chatMsgList, setChatMsgList] = useState([]);

    const fn_postForm = async()=>{
        const date = new Date();
        const form = document.postForm;

        if(form.content.value.trim() != ''){
            Swal.fire({
                title: "처리중입니다.",
                html: "잠시만 기다려주시기 바랍니다.",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },            
            });

            let msg = {
                action : 'chat'
                , roomId : vo.roomId
                , ip : ip
                , content : form.content.value
                , registerDate : new Date(date.getTime() + (9 * 60 * 60 * 1000)).toISOString().split("T")[0] + " " + new Date(date.getTime() + (9 * 60 * 60 * 1000)).toISOString().split("T")[1].split(".")[0]
            }

            fn_sendWs(JSON.stringify(msg));

            const url = process.env.REACT_APP_API_URL + '/chatInsertAction';
            const formData = new FormData();
            const config = {method : 'post', body : formData }
            formData.append("msg", JSON.stringify(msg));
            const data = await api_commonFetch(url, config);
            
            document.postForm.content.value = '';
            document.postForm.content.focus();
            Swal.close();
        }
    }

    const fn_getChatMsgList = async()=>{
        setLoading(true);
        const url = process.env.REACT_APP_API_URL + '/chatMsgList?' + new URLSearchParams(vo);
        const config = {method : 'get'}
        const data = await api_commonFetch(url, config);
        setChatMsgList(data.chatMsgList);
        msgListRef.current.scrollTop = msgListRef.current.scrollHeight;
        setLoading(false);
    }

    const fn_parseJSON = (ob)=>{
        let val = {};
        try{
            val = JSON.parse(ob.msg);
        }catch(err){}
        return val
    }


    useEffect(()=>{
        msgListRef.current.scrollTop = msgListRef.current.scrollHeight;
    }, [msgList]);

    useEffect(()=>{
        //  아이피 가져오기
        fetch("https://api64.ipify.org?format=json").then((res) => res.json()).then((data) => setIp(data.ip)).catch((err) => console.error(err));
        fn_getChatMsgList();
    }, []);

    return (
        <>
            {loading == true ? <Loading/> : ''}

            <div className="chat-list" ref={msgListRef} >
            {
                chatMsgList!=null && chatMsgList.length>0 ? (
                    chatMsgList.map((ob, i)=>{
                        return (
                            <p key={i} className="d-flex">
                                <span className="user-name col-6">
                                    {fn_parseJSON(ob)?.ip}
                                </span>
                                <span className="register-date col-6">
                                    {fn_parseJSON(ob)?.registerDate}
                                </span>
                                <span className="chat-content text-left col-12" dangerouslySetInnerHTML={{__html : fn_parseJSON(ob)?.content}}></span>
                            </p>
                        );
                    })
                ) : ''
            }
            {
                msgList!=null && msgList.length>0?(
                    msgList.map((ob, i)=>{
                        return (
                            <p key={i} className="d-flex">
                                <span className="user-name col-6">
                                    {ob.ip}
                                </span>
                                <span className="register-date col-6">
                                    {ob.registerDate}
                                </span>
                                <span className="chat-content text-left col-12" dangerouslySetInnerHTML={{__html : ob.content}}></span>
                            </p>
                        );
                    })
                ) : ''
            }
            </div>

            <form name="postForm" onSubmit={(e)=>{fn_postForm(); e.preventDefault();}}>
                <input type="hidden" name="ip" defaultValue={ip}/>
                <table className="table">
                    <colgrouop>
                        <col style={{width:'80%'}}/>
                        <col style={{width:'20%'}}/>
                    </colgrouop>
                    <tbody>
                        <tr>
                            <td>
                                <input type="text" name="content"/>                                
                            </td>
                            <td>
                                <button className="btn btn-primary">전송</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </form>
        </>
    );
}